<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      getPropertyValueFor: 'selectedValue',
      selectedBendProtectionA: 'selectedBendProtectionA',
      selectedBendProtectionB: 'selectedBendProtectionB'
    })
  },
  render () {
    return this.$scopedSlots.default({
      cableColor: this.getPropertyValueFor('cables', 'cableColor'),
      fiberCount: this.getPropertyValueFor('cables', 'fiberCount'),
      plugTypeSideA: this.getPropertyValueFor('plugsA', 'plugType'),
      plugTypeSideB: this.getPropertyValueFor('plugsB', 'plugType'),
      plugColorSideA: this.getPropertyValueFor('plugsA', 'plugColor'),
      plugColorSideB: this.getPropertyValueFor('plugsB', 'plugColor'),
      plexSideA: this.getPropertyValueFor('plugsA', 'plex'),
      plexSideB: this.getPropertyValueFor('plugsB', 'plex'),
      cableDiameter: this.getPropertyValueFor('cables', 'diameter'),
      bendProtectionA: this.selectedBendProtectionA,
      bendProtectionB: this.selectedBendProtectionB
    })
  }
}
</script>
